import ApiResponse from "../models/ApiResponse";
import Api from "./Api";
import { TestReportTemplateVersionResponse } from "../models/TestReportTemplateVersionResponse";

class TestReportTemplateApi {
  constructor(private api: Api) {}

  public getTestReportTemplate(): ApiResponse<TestReportTemplateVersionResponse> {
    return this.api.get("/test-request/v2/reporttemplate");
  }

  public verifyTestReportTemplate(formData: FormData) {
    return this.api.post("/test-request/v2/reporttemplate/verify", formData, {
      responseType: "arraybuffer",
    });
  }

  public publishTestReportTemplate(formData: FormData): ApiResponse<TestReportTemplateVersionResponse> {
    return this.api.post("/test-request/v2/reporttemplate/publish", formData);
  }

  public downloadTestReportTemplate(uuid: string, filename: string): ApiResponse<ArrayBuffer> {
    const params = new URLSearchParams();
    params.append("filename", filename);

    return this.api.get(`/test-request/v2/reporttemplate/download/${uuid}`, {
      params,
      responseType: "arraybuffer",
    });
  }
}

export default TestReportTemplateApi;
